import React, { useEffect } from 'react'
import * as api from '../../requests'
import { storeAndDispatchLoginResponse } from '../../Auth/AuthActions'
import { useDispatch } from 'react-redux'
import { Body } from '../Shell/Shell'
import { Spinner } from '../Loaders/Loaders'
import { PaymentError } from '../Checkout/PaymentCallback'
import ls from 'local-storage'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
// import { useMiLoginAuth } from '../MiLogin/providers/AuthProvider'

const OidcCallback = () => {
  // const { authServiceManager } = useMiLoginAuth()

  const dispatch = useDispatch()
  const [error, setError] = React.useState(null)
  const history = useHistory()

  useEffect(async () => {
    //get code from url
    var myUrl = new URL(window.location.href.replace(/#/g, '?'))
    const urlParams = new URLSearchParams(myUrl.search)
    const code = urlParams.get('code')

    const userType = ls.get('MI_LOGIN_USERTYPE')

    api.OIDC_TOKEN_GET(
      code,
      userType,
      (response) => {
        setUserRedux(response)
      },
      (error) => {
        setError(error)
      }
    )
    history.replace('/')
  }, [])

  const setUserRedux = (response) => {
    storeAndDispatchLoginResponse(response, dispatch)
  }

  return (
    <Body className="login-redirector">
      {error ? (
        <div className="payment-callback">
          <PaymentError errorCode={error.code} children={error.message} />
        </div>
      ) : (
        <Spinner className="page-loader" />
      )}
    </Body>
  )
}

export default OidcCallback
